var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPfeilLinks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke-width:0px;}.cls-3{opacity:.75;}.cls-2{fill:#b70d7f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pfad_9-2",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.86,33.95c-1.83-1.24-2.3-3.73-1.06-5.56.28-.42.64-.77,1.06-1.06L41.75.89c1.83-1.24,4.31-.77,5.56,1.06.45.66.69,1.45.69,2.25v52.89c0,2.21-1.79,4-4,4-.8,0-1.59-.24-2.25-.69L2.86,33.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.11,30.64c0,.2.06.57.44.83l38.89,26.44c.43.29.83.16,1.03.06.2-.11.53-.36.53-.88V4.2c0-.52-.33-.78-.53-.88-.2-.11-.6-.24-1.03.06L4.55,29.81c-.38.26-.44.63-.44.83M1.11,30.64c0-1.26.58-2.51,1.75-3.31L41.75.89c2.66-1.81,6.25.1,6.25,3.31v52.89c0,3.21-3.59,5.11-6.25,3.31L2.86,33.95c-1.17-.79-1.75-2.05-1.75-3.31Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfeilLinks);
export default __webpack_public_path__ + "static/media/Pfeil_links.dfab53852615f15809df73ba9206000b.svg";
export { ForwardRef as ReactComponent };